const POINT_ADD = 'https://back-office.elephantstock.net/wishlist/queue/add';
const REMOVE_POINT = 'https://back-office.elephantstock.net/wishlist/queue/remove';
const requestToBOAction = (method, data) => {
    const xhr = new window.XMLHttpRequest();
    xhr.open('POST', method === 'ADD' ? POINT_ADD : REMOVE_POINT);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.onload = function () {
        xhr.status !== 200 && console.log(`Error ${xhr.status}: ${xhr.statusText}`);
    };
    xhr.onerror = function () {
        console.log('connection to server failed');
    };
    xhr.send(JSON.stringify(data));
};
export default requestToBOAction;
